/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewRewardTransaction
 */
export interface NewRewardTransaction {
    /**
     * 
     * @type {string}
     * @memberof NewRewardTransaction
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof NewRewardTransaction
     */
    points?: number;
    /**
     * 
     * @type {Date}
     * @memberof NewRewardTransaction
     */
    createdOn?: Date;
    /**
     * 
     * @type {number}
     * @memberof NewRewardTransaction
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardTransaction
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardTransaction
     */
    courierPackageId?: number;
}

/**
 * Check if a given object implements the NewRewardTransaction interface.
 */
export function instanceOfNewRewardTransaction(value: object): value is NewRewardTransaction {
    return true;
}

export function NewRewardTransactionFromJSON(json: any): NewRewardTransaction {
    return NewRewardTransactionFromJSONTyped(json, false);
}

export function NewRewardTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRewardTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'points': json['points'] == null ? undefined : json['points'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'courierPackageId': json['courierPackageId'] == null ? undefined : json['courierPackageId'],
    };
}

export function NewRewardTransactionToJSON(json: any): NewRewardTransaction {
    return NewRewardTransactionToJSONTyped(json, false);
}

export function NewRewardTransactionToJSONTyped(value?: NewRewardTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'points': value['points'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'courierUserId': value['courierUserId'],
        'courierId': value['courierId'],
        'courierPackageId': value['courierPackageId'],
    };
}

